import React from "react";
import { Tooltip } from "antd";
import "./EllipsisCell.scss";

export interface EllipsisCellProps {
  /** The text; the full value shows in a tooltip when it is cut. */
  text?: string | null;
  /** What to show for an empty value. */
  empty?: React.ReactNode;
  className?: string;
}

/**
 * A single-line cell for the abstract table: long text is cut with an
 * ellipsis (the base table's rows are fixed height, so wrapped text would
 * overlap the next row) and shown in full on hover.
 */
export const EllipsisCell: React.FC<EllipsisCellProps> = ({ text, empty = "-", className }) => {
  if (text === undefined || text === null || text === "") return <>{empty}</>;
  return (
    <Tooltip title={text} mouseEnterDelay={0.4}>
      <span className={`table-cell-ellipsis ${className ?? ""}`.trim()}>{text}</span>
    </Tooltip>
  );
};

/** A column `render` for a plain text field. */
export const ellipsisRender = (empty: React.ReactNode = "-") => (text?: string | null) => <EllipsisCell text={text} empty={empty} />;

export default EllipsisCell;
